// note: the below css class has to be publicly available
export const SCROLL_LOCK_CLASS = 'wb-scroll-lock';

/**
 * @name ScrollLockService
 *
 * @description Locks/unlocks scrolling by adding/removing the `.wb-scroll-lock` class to the documentElement. Used for preventing scrolling of the background behind an open modal
 *
 * @example
 * import { ScrollLockService } from '@workbench/core';
 *
 * const scrollLockService = new ScrollLockService();
 *
 * // lock scrolling
 * scrollLockService.lock();
 *
 * // unlock scrolling
 * scrollLockService.unlock();
 */
export class ScrollLockService {
  public isLocked: boolean;

  private scrollTopBeforeLock: number = 0;

  constructor(public targetEl: HTMLElement = document.documentElement) {}

  public lock(): void {
    if (this.isLocked) {
      return;
    }

    this.scrollTopBeforeLock = this.targetEl.scrollTop;
    this.targetEl.style.top = `-${this.scrollTopBeforeLock}px`;
    this.targetEl.classList.add(SCROLL_LOCK_CLASS);
    this.isLocked = true;
  }

  public unlock(): void {
    if (!this.isLocked) {
      return;
    }

    this.targetEl.classList.remove(SCROLL_LOCK_CLASS);
    this.targetEl.style.top = '';
    this.targetEl.scrollTop = this.scrollTopBeforeLock;
    this.isLocked = false;
  }
}
